import { FileUpload, type FileObjectType } from "@jsq/ds/core";
import useUploadFilesToS3 from "~/hooks/uploadFilesToS3/useUploadFilesToS3";

export type UploadPdfDropzoneProps = {
  onFileUploaded: (objectKey: string, fileName: string) => void;
};

const ACCEPTED_PDF_TYPES = ["application/pdf"];

export const UploadPdfDropzone = ({ onFileUploaded }: UploadPdfDropzoneProps) => {
  const { uploadFilesToS3, loading } = useUploadFilesToS3();

  const handleNewFiles = async (accepted: FileObjectType[]) => {
    const [fileObject] = accepted;
    if (!fileObject) return;

    const [uploaded] = await uploadFilesToS3([fileObject.file]);
    if (uploaded) {
      onFileUploaded(uploaded.objectKey, fileObject.file.name);
    }
  };

  return (
    <FileUpload
      canAllowMultiple={false}
      isFullWidth
      isLoading={loading}
      isDisabled={loading}
      acceptedFileTypes={ACCEPTED_PDF_TYPES}
      onNewFileUploaded={(accepted) => void handleNewFiles(accepted)}
      guidanceMessage="Only PDF files are supported."
      alwaysShowGuidance
      data-testid="ddq-convert-pdf-dropzone"
    />
  );
};
